export default __webpack_public_path__ + "static/0147-3a2ce5901b0e9ec4a2caa76ecc4b2f39.png";